import { EventComp } from "../../components/event/event.comp";
import { LoadingComp } from "../../components/loading/loading.comp";
import { useData } from "../../libs/data/app-data.hook";
import { Event } from "../../libs/data/event";
import { useReferral } from "../../libs/referral/useReferral";

export const CampsView = () => {
  const { referral } = useReferral();
  const { loading, activities } = useData();
  const camps: Array<Event> = (activities?.camp ?? [])
    .filter((camp: Event) => new Date(camp.startDate ?? "") > new Date())
    .sort((a: any, b: any) => (a.startDate < b.startDate ? -1 : 0));

  return (
    <div className="text-center">
      {camps?.map((event) => (
        <EventComp key={event.id} event={event} />
      ))}
      {loading && <LoadingComp />}
    </div>
  );
};
